import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent {
 passwordForm!: FormGroup;
  userImage: string | null = null;

  showPassword = {
    current: false,
    new: false,
    confirm: false
  };

  private subscriptions = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    public userService: UserService,
      private authService: AuthService 
  ) {}

ngOnInit(): void {
  this.passwordForm = this.fb.group({
    currentPassword: ['', Validators.required],
    newPassword: ['', [Validators.required, Validators.minLength(8)]],
    confirmPassword: ['', Validators.required]
  });


  this.userImage = this.userService.getUserImage();
}


  ngOnDestroy() {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  togglePassword(field: 'current' | 'new' | 'confirm') {
    this.showPassword[field] = !this.showPassword[field];
  }

onSave() {
  if (this.passwordForm.valid) {
    const { currentPassword, newPassword, confirmPassword } = this.passwordForm.value;

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Password Mismatch',
        text: 'New password and confirm password do not match',
        confirmButtonColor: '#D0385E',
      });
      return;
    }

    this.authService.changePassword({ 
      oldPassword: currentPassword, 
      newPassword: newPassword 
    }).subscribe({
      next: (response: any) => {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Password updated successfully',
          confirmButtonColor: '#D0385E',
        }).then(() => {
          this.passwordForm.reset();
        });
      },
      error: (err) => {
        console.error('Password change error:', err);
        const errorMessage = err.error?.message || 'Error updating password. Please check your current password.';
        Swal.fire({
          icon: 'error',
          title: 'Password Change Failed',
          text: errorMessage,
          confirmButtonColor: '#D0385E',
        });
      }
    });
  } else {
    Swal.fire({
      icon: 'warning',
      title: 'Invalid Form',
      text: 'Please fill in all required fields correctly',
      confirmButtonColor: '#D0385E',
    });
  }
}
  onCancel() {
    this.passwordForm.reset();
  }
}
